export default {
  "config": {
    "trial": "tones-5",
    "id": "cpap-adh",
    "type": "table",
    "title": "OSA Primary Therapy Device Use Over Time <no-break>(Group A)<sup>24</sup></no-break>",
    "footnotes": [
      "<sup>a</sup>Number of participants with nonmissing values at visit.",
      "<sup>b</sup>Among all participants (with either electronically retrievable or diary data).",
      "<sup>c</sup>Data for this time period were summarized separately for participants who did not enter the randomized withdrawal phase <no-break>(week 28 to 40)</no-break> and for participants who entered the 2-week randomized withdrawal phase <no-break>(week 30 to 40).</no-break>",
      "<sup>d</sup>Among participants with electronically retrievable data.",
      "<sup>e</sup>Among participants with diary data."
    ],
    "useFootnoteTooltip": false
  },
  "data": {
    "trial": "tones-5",
    "id": "cpap-adh",
    "data-type": "table",
    "title": "OSA Primary Therapy Device Use Over Time <no-break>(Group A)<sup>24</sup></no-break>",
    "num-header-rows": 2,
    "num-columns": 7,
    "col-classes": [
      "col-1",
      "obs",
      "obs",
      "obs",
      "change",
      "change",
      "change"
    ],
    "row-mergeoption": [
      1,
      2,
      3,
      11,
      19
    ],
    "footnote-tooltip": "disable",
    "footnote-order": [
      "footnote-a",
      "footnote-b",
      "footnote-c",
      "footnote-d",
      "footnote-e"
    ],
    "footnote-a": "<sup>a</sup>Number of participants with nonmissing values at visit.",
    "footnote-b": "<sup>b</sup>Among all participants (with either electronically retrievable or diary data).",
    "footnote-c": "<sup>c</sup>Data for this time period were summarized separately for participants who did not enter the randomized withdrawal phase <no-break>(week 28 to 40)</no-break> and for participants who entered the 2-week randomized withdrawal phase <no-break>(week 30 to 40).</no-break>",
    "footnote-d": "<sup>d</sup>Among participants with electronically retrievable data.",
    "footnote-e": "<sup>e</sup>Among participants with diary data.",
    "data": {
      "row-0": [
        {
          "content": null,
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<center><b>Observed value</b></center>",
          "cols": 3,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "<center><b>Change from baseline</b></center>",
          "cols": 3,
          "class": "change"
        }
      ],
      "row-1": [
        {
          "content": null,
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<b>N<sup>a</sup></b>",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "<no-break><b>Mean (SD)</b></no-break>",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "<b>Median <no-break>(Q1, Q3)</no-break></b>",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "<b>n<sup>a</sup></b>",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "<no-break><b>Mean (SD)</b></no-break>",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "<b>Median <no-break>(Q1, Q3)</no-break></b>",
          "cols": 1,
          "class": "change"
        }
      ],
      "row-2": [
        {
          "indent": 0,
          "content": "<no-break><b>Nights, %<sup>b</sup></b></no-break>",
          "cols": 7,
          "class": "col-1"
        }
      ],
      "row-3": [
        {
          "indent": 0,
          "content": "Baseline",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": 235,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "90.0 (19.1)",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "100.0 <no-break>(89.3, 100.0)</no-break>",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "–",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "–",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "–",
          "cols": 1,
          "class": "change"
        }
      ],
      "row-4": [
        {
          "indent": 0,
          "content": "Day 1 to week 2",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": 248,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "89.0 (23.9)",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "100.0 <no-break>(92.9, 100.0)</no-break>",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": 228,
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "1.4 (13.3)",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "0.0 <no-break>(0.0, 5.44)</no-break>",
          "cols": 1,
          "class": "change"
        }
      ],
      "row-5": [
        {
          "indent": 0,
          "content": "Week 3 to week 14",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": 234,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "87.1 (26.1)",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "98.9 <no-break>(88.8, 100.0)</no-break>",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": 214,
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.5 (15.2)</no-break>",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "0.0 <no-break>(–1.2, 4.6)</no-break>",
          "cols": 1,
          "class": "change"
        }
      ],
      "row-6": [
        {
          "indent": 0,
          "content": "Week 15 to week 27",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "212",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "88.2 (25.0)",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "100.0 <no-break>(90.8, 100.0)</no-break>",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "197",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "0.3 (13.0)",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "0.0 <no-break>(–1.1, 4.55)</no-break>",
          "cols": 1,
          "class": "change"
        }
      ],
      "row-7": [
        {
          "indent": 0,
          "content": "Week 28 to week 40<sup>c</sup>",
          "cols": 1,
          "class": "col-1",
          "parentRow": true,
          "parent": 7
        },
        {
          "indent": 0,
          "content": "186",
          "cols": 1,
          "class": "obs"
        },
        {
          "content": null,
          "cols": 1,
          "class": "obs"
        },
        {
          "content": null,
          "cols": 1,
          "class": "obs"
        },
        {
          "content": null,
          "cols": 1,
          "class": "change"
        },
        {
          "content": null,
          "cols": 1,
          "class": "change"
        },
        {
          "content": null,
          "cols": 1,
          "class": "change"
        }
      ],
      "row-8": [
        {
          "indent": 1,
          "parent": 7,
          "content": "Week 28 to week 40",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "68",
          "parent": 7,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "89.2 (22.9)",
          "parent": 7,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "100.0 <no-break>(90.7, 100.0)</no-break>",
          "parent": 7,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "62",
          "parent": 7,
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "2.0 (12.3)",
          "parent": 7,
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "0.0 <no-break>(0.0, 4.55)</no-break>",
          "parent": 7,
          "cols": 1,
          "class": "change"
        }
      ],
      "row-9": [
        {
          "indent": 1,
          "parent": 7,
          "content": "Week 30 to week 40",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "118",
          "parent": 7,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "89.5 (24.0)",
          "parent": 7,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "100.0 <no-break>(94.7, 100.0)</no-break>",
          "parent": 7,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "109",
          "parent": 7,
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "0.9 (12.4)",
          "parent": 7,
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "0.0 <no-break>(0.0, 5.14)</no-break>",
          "parent": 7,
          "cols": 1,
          "class": "change"
        }
      ],
      "row-10": [
        {
          "indent": 0,
          "content": "<b>Hours per night<sup>d</sup></b>",
          "cols": 7,
          "class": "col-1"
        }
      ],
      "row-11": [
        {
          "indent": 0,
          "content": "Baseline",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "147",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "6.6 (1.4)",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "6.6 <no-break>(5.8, 7.4)</no-break>",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "–",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "–",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "–",
          "cols": 1,
          "class": "change"
        }
      ],
      "row-12": [
        {
          "indent": 0,
          "content": "Day 1 to week 2",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "138",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "5.9 (2.1)",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "6.4 <no-break>(4.8, 7.4)</no-break>",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "126",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.7 (1.5)</no-break>",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "–0.4 <no-break>(–1.2, 0.2)</no-break",
          "cols": 1,
          "class": "change"
        }
      ],
      "row-13": [
        {
          "indent": 0,
          "content": "Week 3 to week 14",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "134",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "5.7 (2.1)",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "6.1 <no-break>(4.9, 7.1)</no-break>",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "120",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "<no-break>–1.0 (1.7)</no-break>",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "–0.6 <no-break>(–1.5, 0.0)</no-break>",
          "cols": 1,
          "class": "change"
        }
      ],
      "row-14": [
        {
          "indent": 0,
          "content": "Week 15 to week 27",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "116",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "5.9 (2.1)",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "6.2 <no-break>(5.1, 7.2)</nobreak>",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "106",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "–0.9 (1.6)",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "–0.5 <no-break>(–1.5, 0.0)</no-break>",
          "cols": 1,
          "class": "change"
        }
      ],
      "row-15": [
        {
          "indent": 0,
          "content": "Week 28 to week 40<sup>c</sup>",
          "cols": 1,
          "class": "col-1",
          "parentRow": true,
          "parent": 15
        },
        {
          "indent": 0,
          "content": "102",
          "cols": 1,
          "class": "obs"
        },
        {
          "content": null,
          "cols": 1,
          "class": "obs"
        },
        {
          "content": null,
          "cols": 1,
          "class": "obs"
        },
        {
          "content": null,
          "cols": 1,
          "class": "change"
        },
        {
          "content": null,
          "cols": 1,
          "class": "change"
        },
        {
          "content": null,
          "cols": 1,
          "class": "change"
        }
      ],
      "row-16": [
        {
          "indent": 1,
          "parent": 15,
          "content": "Week 28 to week 40",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "40",
          "parent": 15,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "5.9 (2.1)",
          "parent": 15,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "6.1 <no-break>(5.2, 7.4)</no-break>",
          "parent": 15,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "34",
          "parent": 15,
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "–0.9 (1.4)",
          "parent": 15,
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "–0.8 <no-break>(–1.5, 0.0)</no-break>",
          "parent": 15,
          "cols": 1,
          "class": "change"
        }
      ],
      "row-17": [
        {
          "indent": 1,
          "parent": 15,
          "content": "Week 30 to week 40",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "62",
          "parent": 15,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "6.0 (2.0)",
          "parent": 15,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "6.4 <no-break>(5.4, 7.0)</no-break>",
          "parent": 15,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "58",
          "parent": 15,
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "–0.8 (1.7)",
          "parent": 15,
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "–0.5 <no-break>(–1.1, 0.2)</no-break>",
          "parent": 15,
          "cols": 1,
          "class": "change"
        }
      ],
      "row-18": [
        {
          "indent": 0,
          "content": "<b>Nights OSA device was used more than half of <no-break>night<sup>e</sup>, %</no-break>",
          "cols": 7,
          "class": "col-1"
        }
      ],
      "row-19": [
        {
          "indent": 0,
          "content": "Baseline",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "89",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "90.4 (26.1)",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "100.0 <no-break>(100.0, 100.0)</no-break>",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "–",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "–",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "–",
          "cols": 1,
          "class": "change"
        }
      ],
      "row-20": [
        {
          "indent": 0,
          "content": "Day 1 to week 2",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "111",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "91.5 (23.2)",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "100.0 <no-break>(100.0, 100.0)</no-break>",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "83",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "4.1 (16.8)",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "0.0 <no-break>(0.0, 0.0)</no-break>",
          "cols": 1,
          "class": "change"
        }
      ],
      "row-21": [
        {
          "indent": 0,
          "content": "Week 3 to week 14",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "100",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "94.5 (18.8)",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "100.0 <no-break>(100.0, 100.0)</no-break>",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "76",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "5.3 (19.3)",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "0.0 <no-break>(0.0, 0.0)</no-break>",
          "cols": 1,
          "class": "change"
        }
      ],
      "row-22": [
        {
          "indent": 0,
          "content": "Week 15 to week 27",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "95",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "92.7 (21.8)",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "100.0 <no-break>(100.0, 100.0)</no-break>",
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "73",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "3.6 (19.9)",
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "0.0 <no-break>(0.0, 0.0)</no-break>",
          "cols": 1,
          "class": "change"
        }
      ],
      "row-23": [
        {
          "indent": 0,
          "content": "Week 28 to week 40<sup>c</sup>",
          "cols": 1,
          "class": "col-1",
          "parentRow": true,
          "parent": 23
        },
        {
          "indent": 0,
          "content": "83",
          "cols": 1,
          "class": "obs"
        },
        {
          "content": null,
          "cols": 1,
          "class": "obs"
        },
        {
          "content": null,
          "cols": 1,
          "class": "obs"
        },
        {
          "content": null,
          "cols": 1,
          "class": "change"
        },
        {
          "content": null,
          "cols": 1,
          "class": "change"
        },
        {
          "content": null,
          "cols": 1,
          "class": "change"
        }
      ],
      "row-24": [
        {
          "indent": 1,
          "parent": 23,
          "content": "Week 28 to week 40",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "27",
          "parent": 23,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "94.4 (19.7)",
          "parent": 23,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "100.0 <no-break>(100.0, 100.0)</no-break>",
          "parent": 23,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "22",
          "parent": 23,
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "6.2 (21.8)",
          "parent": 23,
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "0.0 <no-break>(0.0, 0.0)</no-break>",
          "parent": 23,
          "cols": 1,
          "class": "change"
        }
      ],
      "row-25": [
        {
          "indent": 1,
          "parent": 23,
          "content": "Week 30 to week 40",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "56",
          "parent": 23,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "94.7 (18.9)",
          "parent": 23,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "100.0 <no-break>(100.0, 100.0)</no-break>",
          "parent": 23,
          "cols": 1,
          "class": "obs"
        },
        {
          "indent": 0,
          "content": "42",
          "parent": 23,
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "6.5 (20.5)",
          "parent": 23,
          "cols": 1,
          "class": "change"
        },
        {
          "indent": 0,
          "content": "0.0 <no-break>(0.0, 0.0)</no-break>",
          "parent": 23,
          "cols": 1,
          "class": "change"
        }
      ]
    }
  }
};